export default __webpack_public_path__ + "static/Entenda0095-3c55a510cf957648c552c91f7a5e1bd9.jpg";